import { css, Interpolation, Theme } from '@emotion/react'

export const blanksCount: Interpolation<Theme> = css`
  margin-bottom: 24px;
`

export const blankTitle: Interpolation<Theme> = (theme) => css`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.typographyColors.typographyTwo};
`

export const option: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
